export default __webpack_public_path__ + "static/media/6.06acba14.svg";